import { __awaiter } from "tslib";
import { get } from 'svelte/store';
import { Backend } from './backend';
import { AppState } from '../etc/stores';
import { Container } from './container';
import { StatefulService } from './stateful-service';
import { SessionManager } from './session-manager';
import flags from '../etc/flagKeys';
import sessionKeys from '../etc/sessionKeys';
export class ReferralProgram extends StatefulService {
    constructor() {
        super(...arguments);
        this.backend = this.ctx.get(Backend);
        this.session = this.ctx.get(SessionManager);
        this.REFERRAL_REFERRED_STATE = 'referral-referred-state';
        this.referralReferredState = this.session.get(this.REFERRAL_REFERRED_STATE);
    }
    loadState() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadReferredState();
            yield this.loadReferringState();
        });
    }
    claimReferredCoupon(params) {
        const linkId = get(AppState).referralReferredState.id;
        return this.backend.claimReferredCouponByLinkId(linkId, params);
    }
    loadReferredState() {
        return __awaiter(this, void 0, void 0, function* () {
            const { auth } = this.getAppState();
            const searchParams = new URLSearchParams(location.search);
            const campaign = searchParams.get('twism-campaign') || searchParams.get('campaign');
            const linkId = searchParams.get('twism-linkId') || searchParams.get('LinkId');
            if ((campaign === 'business-referral' && linkId) ||
                this.session.get(this.REFERRAL_REFERRED_STATE)) {
                let referralReferredState = this.session.get(this.REFERRAL_REFERRED_STATE);
                if (!auth.access_token &&
                    !this.session.get(sessionKeys.BUSINESS_REFERRAL_LINK_ID))
                    this.session.set(sessionKeys.BUSINESS_REFERRAL_LINK_ID, linkId);
                if (!referralReferredState)
                    referralReferredState = yield this.getReferralLinkData(linkId);
                this.session.set(this.REFERRAL_REFERRED_STATE, referralReferredState);
                AppState.update(state => (Object.assign(Object.assign({}, state), { referralReferredState })));
            }
        });
    }
    loadReferringState() {
        return __awaiter(this, void 0, void 0, function* () {
            const { auth, referralLink: oldReferralLink } = this.getAppState();
            const referralProgram = yield this.getAvailableProgram();
            const newReferralCampaignErrorHandler = this.getAppState().featureFlags.includes(flags.NEW_REFERRAL_CAMPAIGN_ERROR_HANDLER);
            if (newReferralCampaignErrorHandler &&
                (!referralProgram ||
                    (typeof referralProgram === 'string' &&
                        !Object.keys(JSON.parse(referralProgram || {})).length))) {
                return;
            }
            let referralLink = oldReferralLink;
            if (auth.access_token) {
                referralLink = yield this.getCustomerLink(referralProgram.id);
            }
            AppState.update(state => (Object.assign(Object.assign({}, state), { referralProgram,
                referralLink })));
        });
    }
    getReferralLinkData(linkId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield this.backend.getReferralByLinkId(linkId);
            }
            catch (err) {
                return {};
            }
        });
    }
    getAvailableProgram() {
        return __awaiter(this, void 0, void 0, function* () {
            const businessId = get(AppState).business.id;
            try {
                if (yield this.backend.isSoftLogin())
                    return { id: undefined };
                return yield this.backend.getBusinessReferral(businessId);
            }
            catch (err) {
                /**
                 * 400 - means the business does not have an active referral program
                 */
                return { isActive: false };
            }
        });
    }
    getCustomerLink(businessReferralId) {
        return __awaiter(this, void 0, void 0, function* () {
            const businessId = get(AppState).business.id;
            try {
                if (yield this.backend.isSoftLogin())
                    return {};
                return yield this.backend.getCustomerReferralLink(businessId);
            }
            catch (err) {
                /**
                 * 404 - means the customer does not have a referral link
                 */
                if (err.response.status === 404) {
                    return yield this.backend.createCustomerReferralLink(businessReferralId);
                }
                return {};
            }
        });
    }
}
Container.add(ReferralProgram);
